module.exports = __webpack_public_path__ + "img/footer_cover.f33c75e.png";